import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import Topnav from "../common/Topnav";
import media15 from "../../Images/media/news.webp";
import bannerImage from "../../Images/Banner/acadmic.webp";
import Footer from "../common/Footer";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Accordion, Card } from "react-bootstrap";

const WorkIsbm = () => {

    const [modalShow, setModalShow] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <title>Careers at ISBM University – Join Our Team</title>
            <meta
                name="description"
                content="Explore career opportunities at ISBM University — faculty and staff roles with growth, innovation and a supportive work environment. Apply now!"
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="conatiner-xxl">
                        <div className="section-hero-content">
                            <h1>Work at ISBM University</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Work at ISBM University
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            {/* Main Content */}
            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <h2 className="modern-title text-blue">
                        Work at ISBM University
                    </h2>
                    <div className="underline-divider mb-5"></div>
                    <Row>
                        <Col lg={6} className="mb-3">
                            <div className="governing-image-wrapper shadow">
                                <img src={classroomImage} alt="Governing Body" />
                            </div>
                        </Col>
                        <Col lg={6}>

                            <p>
                                ISBM University offers various job opportunities for individuals
                                interested in contributing to its academic and administrative
                                functions. Here are some key aspects:
                            </p>

                            <ul>
                                <li className="mb-2">
                                    <strong className="text-blue">1. Academic Positions:</strong>{" "}
                                    The University frequently seeks qualified faculty members for
                                    various departments such as Professors, Associate Professors,
                                    and Assistant Professors.
                                </li>
                                <li className="mb-2">
                                    <strong className="text-blue">2. Administrative Roles:</strong>{" "}
                                    Openings in admissions, finance, HR, marketing, and student services.
                                </li>
                                <li className="mb-2">
                                    <strong className="text-blue">3. Support Staff:</strong>{" "}
                                    Positions like lab technicians, library staff, and IT support.
                                </li>
                                <li className="mb-2">
                                    <strong className="text-blue">4. Career Development Programs:</strong>{" "}
                                    Includes workshops and training programs for employee skill development.
                                </li>
                                <li className="mb-2">
                                    <strong className="text-blue">5. Recruitment Process:</strong>{" "}
                                    Check the University's official website or job portals for openings and criteria.
                                </li>
                            </ul>

                            <p>
                                ISBM University aims to attract and retain talented individuals
                                by supporting professional growth within a vibrant academic environment.
                            </p>
                        </Col>
                    </Row>
                </div>
            </section>

            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <div className="other" id="jobAccordion">
                        {/* Accordion Item 1 – Job Table */}
                        <div className="other-item mb-3">
                            <h2 className="other-header" id="heading-job">
                                <button
                                    className="other-button fw-bold bg-primary-custom shadow"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse-job"
                                    aria-expanded="true"
                                    aria-controls="collapse-job"
                                >
                                    <div className="d-flex justify-content-between align-items-center w-100">
                                        <span className="committee-title">📋 Job Openings Table</span>
                                        <i className="bi bi-chevron-up toggle-icon"></i>
                                    </div>
                                </button>
                            </h2>
                            <div
                                id="collapse-job"
                                className="other-collapse collapse show"
                                aria-labelledby="heading-job"
                                data-bs-parent="#jobAccordion"
                            >
                                <div className="other-body p-0">
                                    <table className="table table-bordered mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th scope="col">SN</th>
                                                <th scope="col">Name of Post</th>
                                                <th scope="col">School Discipline</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>
                                                    Professor / Associate Professor / Assistant Professor
                                                    <br />
                                                    <strong>Qualification & Experience:</strong> As per UGC / BCI / PCU / AICTE norms.
                                                    <br />
                                                    <br />
                                                    Dean (Academic)
                                                </td>
                                                <td>
                                                    History, Education, English, Hindi, Political Science, Sanskrit, Economics, Geography, Sociology,
                                                    Social Work, Film Making, Yoga Science, Nutrition, Journalism & Mass Communication, Public
                                                    Administration, Psychology, Philosophy, Chhattisgarhi, Zoology, Chemistry, Physics, Botany,
                                                    Mathematics, Biotechnology, Microbiology, Biochemistry, Clinical Research, Public Health,
                                                    Forestry, Fashion Designing, Interior Designing, Commerce & Management, Law, Library & Info
                                                    Science, Engineering (Mining, Electrical, Civil, Mechanical, CSE), Pharmacy, IT, Event
                                                    Management, Disaster Management, Physiotherapy, Sericulture, Data Science, Defence Studies,
                                                    Forensic Science
                                                    <br />
                                                    <br />
                                                    Dean Research, DSW (As per UGC norms)
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Non Academic</td>
                                                <td>
                                                    Controller of Examinations, Training and Placement Officer, Warden (Girls & Boys Hostel),
                                                    Sports Officer, Music Teacher, Gym Trainer, System Administrator, Software Developer,
                                                    Marketing Manager & Executives
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Accordion Item 2 – Image */}
                        <div className="other-item">
                            <h2 className="other-header" id="heading-image">
                                <button
                                    className="other-button fw-bold bg-primary-custom shadow collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapse-image"
                                    aria-expanded="false"
                                    aria-controls="collapse-image"
                                >
                                    <div className="d-flex justify-content-between align-items-center w-100">
                                        <span className="committee-title">📌 Recruitment Notice</span>
                                        <i className="bi bi-chevron-down toggle-icon"></i>
                                    </div>
                                </button>
                            </h2>
                            <div
                                id="collapse-image"
                                className="other-collapse collapse"
                                aria-labelledby="heading-image"
                                data-bs-parent="#jobAccordion"
                            >
                                <div className="other-body p-3 text-center">
                                    <img
                                        className="recruitment rounded shadow-sm"
                                        src={media15}
                                        alt="Recruitment Notice"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <Footer />
        </>
    );
};

export default WorkIsbm;
